import { cn } from "@/utils";
import { Button } from "@mantine/core";
import { t } from "i18next";
import { LucideBoxSelect, LucidePlus } from "lucide-react";
import { ButtonLink } from "../links";

export function EmptyState({
  resourceType,
  hasActiveFilters,
  onCreate,
  onClearFilters,
  hideReturnHome,
  className,
  size = "md",
  hideIcon = false,
}: {
  resourceType?:
    | "trip"
    | "trips.trip"
    | "trips.client"
    | "trips.discountCode"
    | "reservation"
    | "reservations.trip"
    | "reservations.client"
    | "reservations.discountCode"
    | "reservations.all"
    | "clients"
    | "client"
    | "employees"
    | "employee"
    | "role"
    | "roles"
    | "finance.ledger"
    | "auditLog"
    | "payments"
    | "agency"
    | "discountCodes"
    | "discountCode"
    | "withdrawal"
    | "withdrawals";
  hideIcon?: boolean;
  hasActiveFilters?: boolean;
  onCreate?: () => void;
  onClearFilters?: () => void;
  hideReturnHome?: boolean;
  size?: "sm" | "md";
  className?: string;
}) {
  return (
    <div
      className={cn(
        "flex grow flex-col items-center justify-center rounded-lg text-center",
        size === "sm" ? "p-md min-h-75" : "p-xl min-h-100 border border-dashed",
        className,
      )}
    >
      {!hideIcon ? (
        <div
          className={cn(
            "bg-primary-light mx-auto flex items-center justify-center rounded-full",
            size === "sm" ? "size-12" : "size-16",
          )}
        >
          <LucideBoxSelect className={cn("text-primary-light-color", size === "sm" ? "size-6" : "size-8")} />
        </div>
      ) : null}
      <h3 className={cn("text-primary-light-color mt-1.5 font-semibold", size === "sm" ? "text-lg" : "text-xl")}>
        {t(
          resourceType
            ? `${resourceType}.empty.${hasActiveFilters ? "filters.title" : "noFilters.title"}`
            : `empty.${hasActiveFilters ? "filters" : "noFilters"}.title`,
        )}
      </h3>
      <p className={cn("text-text", size === "sm" ? "text-sm" : "text-base")}>
        {t(
          resourceType
            ? `${resourceType}.empty.${hasActiveFilters ? "filters" : "noFilters"}.description`
            : `empty.${hasActiveFilters ? "filters" : "noFilters"}.description`,
        )}
      </p>

      <div className="mt-lg gap-sm flex items-center">
        {hideReturnHome !== true && !hasActiveFilters ? <ButtonLink to="/">{t("returnHome")}</ButtonLink> : null}
        {onClearFilters && hasActiveFilters ? (
          <Button onClick={onClearFilters} variant="default">
            {t("filters.clear")}
          </Button>
        ) : null}
        {onCreate ? (
          <Button onClick={onCreate} leftSection={<LucidePlus className="size-4" />}>
            {t(resourceType ? `${resourceType}.new` : "empty.new")}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
